import $ from 'jquery';
import 'jquery.mmenu';

const mobile_menu = $('#mobile_menu_js');
const mobile_toggle = $('#mobile_toggle_js');
const quick_links_menu = $('#quick_links_js').html();

mobile_menu.find('> ul').append(quick_links_menu);

mobile_menu.mmenu({
  offCanvas: {
    position: 'right'
  },
  counters: true,
  slidingSubmenus: true,
  navbars: [
    {
      position: 'top'
    }
  ]
});

const API = mobile_menu.data('mmenu');

mobile_toggle.click(function(event) {
  event.preventDefault();

  $(this).toggleClass('is-active');
  API.open();
});

$('#mm-blocker').on('click mousedown touchstart', function() {
  mobile_toggle.removeClass('is-active');
});

/**
 * Use foundation to check the media queries change,
 * when they are set above the small breakpoint
 * close the mobile menu.
 */
$(window).on('changed.zf.mediaquery', function(event, newSize){
  if ( newSize !== 'small' ) {
    API.close();
  }
});
